import { render, staticRenderFns } from "./Capital.vue?vue&type=template&id=25fc7328&scoped=true"
import script from "./Capital.vue?vue&type=script&lang=js"
export * from "./Capital.vue?vue&type=script&lang=js"
import style0 from "./Capital.vue?vue&type=style&index=0&id=25fc7328&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fc7328",
  null
  
)

export default component.exports